<button type="button" class="info-button" [ngbPopover]="popTemplate"
        triggers="manual" [autoClose]="false" placement="auto" [container]="container() || null"
        [popoverClass]="'info-popover'"
        (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <i class="fa fa-question-circle"></i>
</button>

<ng-template #popTemplate>
  <div (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">{{info()}}</div>
</ng-template>
